<template>
  <v-container>
    <v-form ref="form">

      <v-row class="space-between mt-4">
        <v-col
          cols="12"
        >
          <v-textarea
          counter
          label="お問い合わせ・ご意見などをご自由にお聞かせください"
          v-model="input.text"
          requer
          :rules="textRules"
          requ
      ></v-textarea>
        </v-col>
      </v-row>

      <v-row justify="space-between">
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
              label="お名前（任意）"
              v-model="input.name"
              >
          </v-text-field>
          <v-text-field
              label="メールアドレス（任意）"
              v-model="input.email"
              >
          </v-text-field>
        </v-col>
      </v-row>

    </v-form>


    <v-row
      class="justify-center  align-center mt-3"
    >
      <v-btn
          width="140"
          rounded
          color="deep-purple"
          dark
          :loading="isLoading"
          @click="sendOpinionRequest()"
      >
          <span v-if="!isSended">送信する</span>
          <span v-if="isSended">送信済</span>
      </v-btn>
    </v-row>

    <v-row
      class="justify-center  align-center mt-12"
    >
      {{ result_message }}
    </v-row>

  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: "SendOpinionEmail",
  data(){
    return {
      input: {
          text: '',
          name: '',
          email: '',
      },
      textRules: [
        v => !!v || '問合せ内容を入力してください',
        v => (v && v.length <= 500) || '500文字以内で入力ください'
      ],
      isLoading: false,
      isSended: false,
      result_message: null
    }
  },
  methods:{
    sendOpinionRequest(){
        //入力値にエラーがあればreturn
        if(!this.$refs.form.validate()) return;
        if(this.isSended) return;

        this.isLoading = true;

        // apiへの送信情報を定義
        const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/contact";
        const postData = {
          text: this.input.text,
          name: this.input.name,
          email: this.input.email
        };
        const headers = {
            headers: {
                "Content-Type": "application/json"
            }
        } 
        axios.post(apiUrl,postData,headers)
          .then((res) => {
            console.log(res);
            this.result_message = 'ご意見を承りました。ご協力、誠にありがとうございます。';
            this.isSended = true;
          })
          .catch((err) => {
            console.log(err);
            this.result_message = '送信エラーが発生いたしました。お手数ですが、もう1度送信をお願い致します。'
          })
          .finally(() => { 
              this.isLoading = false;
          })
    },
  }
}
</script>